module.exports = __webpack_public_path__ + "static/media/10.1e120173.jpg";